import { render, staticRenderFns } from "./editadmin.vue?vue&type=template&id=2594466b&"
import script from "./editadmin.vue?vue&type=script&lang=js&"
export * from "./editadmin.vue?vue&type=script&lang=js&"
import style0 from "./editadmin.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports